module.exports = __webpack_public_path__ + "img/31.b831d165.svg";